export const countryConstants = {
    US: {
        currency: {
            symbol: '$',
            thousandsDelimiter: ',',
            decimalDelimiter: '.'
        },
        date: {
            momentJsFormat: 'MM/DD/YYYY',
            delimiter: '/',
            cleavePattern: ['m', 'd', 'Y']
        },
        phone: {
            countryCode: '+1',
            regex: '' // FOR PHONE VALIDATION
        }
    },
    //REVISIT AND FIX THE CURRENCY FORMAT FOR GERMANY
    DE: {
        currency: {
            symbol: '€',
            thousandsDelimiter: '.',
            decimalDelimiter: ','
        },
        date: {
            momentJsFormat: 'DD.MM.YYYY',
            delimiter: '.',
            cleavePattern: ['d', 'm', 'Y']
        },
        phone: {
            countryCode: '+49',
            regex: '' // FOR PHONE VALIDATION
        }
    },
    UK: {
        currency: {
            symbol: '£',
            thousandsDelimiter: ',',
            decimalDelimiter: '.'
        },
        date: {
            momentJsFormat: 'DD/MM/YYYY',
            delimiter: '/',
            cleavePattern: ['d', 'm', 'Y']
        },
        phone: {
            countryCode: '+44',
            regex: '' // FOR PHONE VALIDATION
        }
    },
    AUS: {
        currency: {
            symbol: 'A$',
            thousandsDelimiter: ',',
            decimalDelimiter: '.'
        },
        date: {
            momentJsFormat: 'DD/MM/YYYY',
            delimiter: '/',
            cleavePattern: ['d', 'm', 'Y']
        },
        phone: {
            countryCode: '+61',
            regex: '' // FOR PHONE VALIDATION
        }
    }
};

export const englishVariant = {
    american: {
        // USE CAPITALIZED VERSIONS HERE. GOING "ToLowerCase" IS EASIER THAN CAPITALIZING JUST CERTAIN LETTERS IF NEEDED
        center: 'Center',
        deductible: 'Deductible',
        confirmScreen: 'You will receive a replacement device within 1 to 3 business days.',
        idProofDesc:
            'Official identification forms issued by the Government of the United States that validates your name, address, and residency status, along with a picture.'
    },
    british: {
        // USE CAPITALIZED VERSIONS HERE. GOING "ToLowerCase" IS EASIER THAN CAPITALIZING JUST CERTAIN LETTERS IF NEEDED
        center: 'Centre',
        deductible: 'Excess Fee',
        confirmScreen: '',
        idProofDesc: 'Driving Licence or Passport.'
    }
};
